export {
  AXIS_ORDER,
  PICK_EDGE_ON_THRESHOLD,
  PICK_RADIAL_TOLERANCE,
} from '../constants';
export { AXIS_COLOR_BY_KEY } from '../../constants';

export const LOCKED_RING_COLOR = 0x6b7280;
export const ACTIVE_RING_OPACITY = 0.78;
export const IDLE_RING_OPACITY = 0.38;
export const LOCKED_RING_OPACITY = 0.15;
export const SWEEP_FILL_OPACITY = 0.25;

// three.js TransformControls rotate X/Y/Z use CircleGeometry(0.5, 0.5).
export const RING_RADIUS = 0.56;
export const RING_RIBBON_HALF_WIDTH = 0.048;
export const LOCKED_RING_RIBBON_HALF_WIDTH = RING_RIBBON_HALF_WIDTH * 0.3;
export const RING_SEGMENT_COUNT = 72;

export const HANDLE_WIDTH_FACTOR = 1.6;
export const HANDLE_PICK_SCALE = 2.5;
export const HANDLE_RADIAL_LIFT = 0.003;
export const HANDLE_ANGLE_DEGREES = 180;
export const HANDLE_CORNER_RADIUS_FACTOR = 0.85;

export const MIN_LIMIT_RANGE_DEGREES = 3;

export const UNLIMITED_HANDLE_MIN_DEGREES = -180;
export const UNLIMITED_HANDLE_MAX_DEGREES = 180;

export const LOCK_PILL_TOP_RIGHT_FACTOR = 1.5;

export const PREVIEW_MIN_RANGE_DEGREES = 0.5;
export const PREVIEW_DEGREES_PER_SECOND = 180;
export const PREVIEW_MIN_SEGMENT_DURATION_MS = 240;
export const PREVIEW_APPLY_EPSILON_DEGREES = 1e-3;
